@for (modal of modals | async; track modal.id) { @if (modal.show) {
<div
    #modalContainer
    [attr.data-modal-id]="modal.id"
    class="fixed inset-0 z-50 flex app-modal-backdrop bg-black/50 backdrop-blur-lg"
    (click)="backdropClick($event, modal.id)"
    [ngClass]="{
        'justify-center': modal.position === 'center' || modal.position === 'top' || modal.position === 'bottom',
        'items-center': modal.position === 'center' || modal.position === 'left' || modal.position === 'right',
        'items-start': modal.position === 'top',
        'items-end': modal.position === 'bottom',
        'justify-start': modal.position === 'left',
        'justify-end': modal.position === 'right'
    }"
>
    <div
        class="relative transition-all bg-white rounded-lg shadow-lg app-modal-box"
        [ngClass]="{
            'animate-fade-in': modal.animation === 'fade' && modal.show,
            'animate-slide-in': modal.animation === 'slide' && modal.show,
            'animate-zoom-in': modal.animation === 'zoom' && modal.show,
            'w-[22rem]': modal.size === 'sm',
            'w-[28rem]': modal.size === 'md',
            'w-[36rem]': modal.size === 'lg',
            'w-[48rem]': modal.size === 'xl',
            'w-[95vw]': modal.size === 'full'
        }"
        [style.marginTop]="modal.position === 'top' ? '3rem' : ''"
        [style.marginBottom]="modal.position === 'bottom' ? '3rem' : ''"
        [style.marginLeft]="modal.position === 'left' ? '3rem' : ''"
        [style.marginRight]="modal.position === 'right' ? '3rem' : ''"
        style="max-height: 90vh; display: flex; flex-direction: column"
    >
        <div class="relative flex flex-col w-full max-h-full">
            <div class="relative bg-white rounded-lg shadow-sm flex flex-col max-h-[90vh]">
                <div class="flex items-center justify-between flex-shrink-0 p-4 border-b rounded-t md:p-5">
                    <h3 class="text-xl font-semibold text-slate-900">
                        {{ modal.title }}
                    </h3>
                    @if (modal.showCloseButton !== false) {
                    <button
                        type="button"
                        (click)="modalService.close(modal.id)"
                        class="inline-flex items-center justify-center w-8 h-8 text-sm bg-transparent rounded-lg text-slate-700 ms-auto hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
                        aria-label="Close modal"
                        tabindex="0"
                    >
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14"
                        >
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                            />
                        </svg>
                        <span class="sr-only">Close modal</span>
                    </button>
                    }
                </div>
                <div class="flex-1 p-4 space-y-4 overflow-y-auto md:p-5" (click)="contentClick($event, modal.id)">
                    @if (modal.contentTemplate) {
                    <ng-container
                        [ngTemplateOutlet]="modal.contentTemplate"
                        [ngTemplateOutletContext]="modal.contentData"
                    ></ng-container>
                    } @else if (modal.contentComponent) {
                    <div class="dynamic-component-container"></div>
                    } @else if (modal.content) {
                    <div class="mb-4">{{ modal.content }}</div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
} }
